export const API_CONTOUR_LEGACY = "legacy";
export const API_CONTOUR_ORCHESTRATOR = "orchestrator";

const API_CONTOUR_STORAGE_KEY = "api_contour";
const SUPPORTED_CONTOURS = [API_CONTOUR_LEGACY, API_CONTOUR_ORCHESTRATOR];

class ApiContourService {
  normalize(contour) {
    if (typeof contour !== "string") {
      return null;
    }

    const normalized = contour.trim().toLowerCase();
    return SUPPORTED_CONTOURS.includes(normalized) ? normalized : null;
  }

  getConfiguredBaseUrl(contour) {
    if (contour === API_CONTOUR_LEGACY) {
      return process.env.VUE_APP_API_HOST || "";
    }

    if (contour === API_CONTOUR_ORCHESTRATOR) {
      return process.env.VUE_APP_OPERATOR_API_HOST || "";
    }

    return "";
  }

  initialize() {
    const storedContour = this.normalize(window.sessionStorage.getItem(API_CONTOUR_STORAGE_KEY));
    const contour = storedContour && this.getConfiguredBaseUrl(storedContour)
      ? storedContour
      : API_CONTOUR_LEGACY;

    if (storedContour && contour !== storedContour) {
      window.sessionStorage.removeItem(API_CONTOUR_STORAGE_KEY);
    }

    return {
      baseUrl: this.getConfiguredBaseUrl(contour),
      contour,
    };
  }

  getCurrentContour() {
    return this.initialize().contour;
  }

  activate(contour) {
    const normalized = this.normalize(contour);
    if (!normalized) {
      return { ok: false, reason: "unsupported_contour" };
    }

    const baseUrl = this.getConfiguredBaseUrl(normalized);
    if (!baseUrl) {
      return { ok: false, reason: "missing_api_host" };
    }

    window.sessionStorage.setItem(API_CONTOUR_STORAGE_KEY, normalized);

    return {
      baseUrl,
      contour: normalized,
      ok: true,
    };
  }
}

export default new ApiContourService();
